import { MatxLoading } from "app/components";
import { logoutZohoDesk } from "app/components/ZohoDeskWidget";
import axios from "axios";
import { createContext, useEffect, useReducer } from "react";

const initialState = {
  user: null,
  isInitialised: false,
  isAuthenticated: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "INIT": {
      const { isAuthenticated, user } = action.payload;
      return { ...state, user, isAuthenticated, isInitialised: true };
    }
    case "LOGIN": {
      const { user } = action.payload;
      return { ...state, user, isAuthenticated: true };
    }
    case "LOGOUT": {
      return { ...state, isAuthenticated: false, user: null };
    }
    case "REGISTER": {
      const { user } = action.payload;
      return { ...state, isAuthenticated: true, user };
    }
    default: {
      return state;
    }
  }
};

const AuthContext = createContext({
  ...initialState,
  method: "JWT",
  logout: () => { },
  login: () => Promise.resolve(),
  register: () => Promise.resolve(),
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const logout = async () => {
    await logoutZohoDesk();
    window.location.href = '/account/logout';
  };

  axios.interceptors.request.use(function (config) {
    const accountId = localStorage.getItem("accountId");
    if (!accountId || accountId.length === 0) {
      if (window.location.pathname !== '/choose-account' && window.location.pathname !== '/register' && window.location.pathname !== '/register-frame' && window.location.pathname !== '/confirm-email' && window.location.pathname !== '/logged-out')
        window.location.href = '/choose-account';
    }
    config.headers.accountId = accountId;
    return config;
  });

  useEffect(() => {
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (err) => {
        return new Promise((resolve, reject) => {
          if (
            err.message === "Network Error"
          ) {
            if (window.location.pathname !== '/register' && window.location.pathname !== '/register-frame' && window.location.pathname !== '/logged-out')
              window.location.reload();
          }
          throw err;
        });
      }
    );

    (async () => {
      try {
        const response = await axios.get("/api/self");
        const { data: user } = response;

        dispatch({
          type: "INIT",
          payload: { isAuthenticated: true, user },
        });
      } catch (err) {
        dispatch({
          type: "INIT",
          payload: { isAuthenticated: false, user: null },
        });
      }
    })();
  }, []);

  if (!state.isInitialised && window.location.pathname !== '/register' && window.location.pathname !== '/register-frame' && window.location.pathname !== '/logged-out') {
    return <MatxLoading />;
  }

  return (
    <AuthContext.Provider value={{ ...state, method: "JWT", logout: logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
